import React from 'react'
import {
    Text,
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalFooter,
    ModalBody,
    Flex,
} from '@salesforce/retail-react-app/app/components/shared/ui'
import PropTypes from 'prop-types'
import {CloseIcon} from '../icons'
import {remCalc} from '../../theme/_utils'
import {useIntl} from 'react-intl'

const GenericModal = ({isOpen, onClose, children, width}) => {
    const intl = useIntl()

    return (
        <Modal isOpen={isOpen} onClose={onClose} blockScrollOnMount={false} isCentered>
            <ModalOverlay />
            <ModalContent
                {...{
                    maxWidth: remCalc(640),
                }}
                width={width || 'auto'}
                mx={remCalc(16)}
            >
                <ModalHeader
                    {...{position: 'absolute', top: 0, right: 0}}
                    padding={`${remCalc(24)}`}
                >
                    <Flex flexDir="row" justifyContent="space-between" alignItems="center">
                        <Text></Text>

                        <CloseIcon
                            data-testid="close-button"
                            onClick={onClose}
                            aria-label={intl.formatMessage({
                                id: 'subscription_edit_not_allowed.close',
                                defaultMessage: 'Close',
                            })}
                            tabIndex={0}
                            _focusVisible={{
                                border: 'small',
                                borderColor: 'button.border.primary-focused',
                                borderStyle: 'solid',
                            }}
                        />
                    </Flex>
                </ModalHeader>
                <ModalBody
                    p={{
                        base: 'small.base',
                        md: 'small.md',
                        lg: 'small.lg',
                        xl: 'small.xl',
                    }}
                    data-testid="modal-body"
                >
                    {children}
                </ModalBody>
                <ModalFooter display={'none'}></ModalFooter>
            </ModalContent>
        </Modal>
    )
}

GenericModal.propTypes = {
    isOpen: PropTypes.bool,
    onClose: PropTypes.func,
    children: PropTypes.node,
    width: PropTypes.string,
}

export default GenericModal
